export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/realistic_drawing.b1551d7.png";